import { sha1 } from 'js-sha1'

export function generatePureSpectrumHash(
  fullUrl: string,
  secretKey: string
): string {
  return sha1(fullUrl + secretKey)
}

export function buildAndSignPureSpectrumUrl(
  fullUrl: string,
  secretKey: string
): string {
  // Generate hash and append
  const hash = generatePureSpectrumHash(fullUrl, secretKey)
  return `${fullUrl}&ps_hash=${hash}`
}
